export default __webpack_public_path__ + "static/media/BurfordRusticOutline.b9c72612.otf";